import { IItemAttributeRateKey } from '../../interfaces/iitem-attribute-rate-key';
import { ItemAttribute } from '../item-attribute';
import { ItemRate } from '../item-rate';
import { ResourceCalculation } from '../resource-calculation';

export class ItemAttributeRateKeyBase {
  ItemAttributeRateKeyId: number;
  ItemAttributeId: number;
  ItemRateId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ResourceCalculationId: number | null;

  ItemAttribute?: ItemAttribute;
  ItemRate?: ItemRate;
  ResourceCalculation?: ResourceCalculation;

  constructor(item?: IItemAttributeRateKey) {
    if (item) {

      this.ItemAttributeRateKeyId = item.ItemAttributeRateKeyId;
      this.ItemAttributeId = item.ItemAttributeId;
      this.ItemRateId = item.ItemRateId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ResourceCalculationId = item.ResourceCalculationId;

      this.ItemAttribute = new ItemAttribute(item.ItemAttribute);
      this.ItemRate = new ItemRate(item.ItemRate);
      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
    }
  }
}